export default {
	apiUrl: process.env.REACT_APP_API_URL,
	inboxApiUrl: process.env.REACT_APP_INBOX_API_URL
}
